// | ------------------------------------------------------------------------
// | Product Filters
// | ------------------------------------------------------------------------

import { OverlayScrollbars } from "overlayscrollbars";

const filters = document.querySelector(".product-filters");
if (filters) {
    // Set Custom Properties needed to calculate the height of the filters
    const calcFilterHeight = () => {
        const filterHeader = document.querySelector(".product-filters-header");
        const filterFooter = document.querySelector(".product-filters-footer");

        const setFilterHeight = (element, cssVar) => {
            const height = element ? element.offsetHeight : 0;
            document.documentElement.style.setProperty(cssVar, `${height}px`);
        };

        setFilterHeight(filterHeader, "--filter-header-height");
        setFilterHeight(filterFooter, "--filter-footer-height");
    };

    // Run on scroll/load/resize
    // Run on scroll/load/resize
    ["scroll", "load", "resize"].forEach((event) =>
        window.addEventListener(event, calcFilterHeight, false)
    );

    // Resize sticky filter button when it becomes sticky
    window.onscroll = () => {
        const el = document.querySelector(".product-filters-column");
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
            { threshold: [1] }
        );
        observer.observe(el);
    };

    // Add custom scroll bar to the filters when needed
    OverlayScrollbars(document.querySelector(".product-filters-body"), {
        overflow: {
            x: "hidden",
        },
        scrollbars: {
            visibility: "auto",
            autoHide: "leave",
        },
    });

    // Open and close filters on mobile devices
    window.addEventListener("load", (event) => {
        // Set variables
        const body = document.querySelector("body");
        const filters = document.querySelector(".product-filters");
        const button = document.querySelector(".product-filters-button");
        const closeButton = document.querySelector(".close-filters-button");
        let windowWidth = document.body.clientWidth;

        // Toggle menu function
        var toggleDrawer = function () {
            body.classList.toggle("filters-open");
            button.classList.toggle("toggled");
            document.documentElement.classList.toggle("no-scroll");
        };

        if (button) {
            // Open/close filters using button
            button.addEventListener("click", (event) => {
                event.stopPropagation();
                toggleDrawer();
            });

            // Prevent filters from closing when clicked
            filters.addEventListener("click", (event) => event.stopPropagation());

            // Close filters when clicking off them
            body.addEventListener("click", () => {
                if (body.classList.contains("filters-open")) toggleDrawer()
            });

            // Close filters when clicking close button
            closeButton.addEventListener("click", () => {
                if (body.classList.contains("filters-open")) toggleDrawer()
            });

            // Close filters if window is resized
            window.addEventListener("resize", () => {
                if (document.body.clientWidth !== windowWidth) {
                    if (body.classList.contains("filters-open")) toggleDrawer();
                }
                windowWidth = document.body.clientWidth;
            });
        }
    });
}



// ─── New Sub-category Filters ────────────────────────────────────────────────

/**
 * .nav
 *  .nav-item
 *    .nav-link.nav-item subcat-toggle (active) (open) - data-menu="#subcat-{id}"
 * 
 * .subcat-menu-grid
 *      .subcat-menu (active) - id=
 * 
 */

document.addEventListener("DOMContentLoaded", function () {

    const TOPINDEX = 100

    const navLinks = document.querySelectorAll(".subcat-toggle")
    let activeMenu = null // Tracks the currently active menu
    let hideMenuTimeout = null // Timer for hiding menus

    // Find the default open nav-link on page load
    const defaultLink = document.querySelector(".subcat-toggle.open")
    const defaultMenu = defaultLink ? document.querySelector(defaultLink.getAttribute("data-menu")) : null

    // Function to activate a menu
    const showMenu = (link, submenu) => {
        clearTimeout(hideMenuTimeout); // Cancel any hiding timers
        if (activeMenu) {
            activeMenu.link.classList.remove("open")
            activeMenu.submenu.classList.remove("active")
            activeMenu.submenu.style.zIndex = 1
        }
        link.classList.add("open")
        submenu.classList.add("active")
        submenu.style.zIndex = TOPINDEX
        activeMenu = { link, submenu }
    };

    // Function to deactivate all menus and show the default
    const showDefaultMenu = () => {
        clearTimeout(hideMenuTimeout) // Cancel hiding timers
        if (activeMenu) {
            activeMenu.link.classList.remove("open")
            activeMenu.submenu.classList.remove("active")
            activeMenu.submenu.style.zIndex = 1
        }
        if (defaultLink && defaultMenu) {
            defaultLink.classList.add("open")
            defaultMenu.classList.add("active")
            defaultMenu.style.zIndex = TOPINDEX
            activeMenu = { link: defaultLink, submenu: defaultMenu }
        } else {
            activeMenu = null
        }
    };

    // Function to hide the current menu
    const hideMenu = () => {
        hideMenuTimeout = setTimeout(showDefaultMenu, 100) // Small delay to prevent flickering
    };

    navLinks.forEach((link) => {
        const menuSelector = link.getAttribute("data-menu")
        const submenu = document.querySelector(menuSelector)

        if (menuSelector && !submenu) {
            link.addEventListener("mouseenter", () => {
                clearTimeout(hideMenuTimeout) // Cancel hiding timers
                if (activeMenu) {
                    activeMenu.link.classList.remove("open")
                    activeMenu.submenu.classList.remove("active")
                    activeMenu.submenu.style.zIndex = 1
                }
            })
            link.addEventListener("mouseleave", (event) => hideMenu());
        }

        if (!submenu) return


        // Hover events for the nav-link
        link.addEventListener("mouseenter", () => showMenu(link, submenu))
        link.addEventListener("mouseleave", (event) => {
            if (submenu && !submenu.contains(event.relatedTarget)) {
                hideMenu()
            }
        });

        // Hover events for the submenu
        submenu.addEventListener("mouseenter", () => {
            clearTimeout(hideMenuTimeout) // Cancel hiding if hovering over the submenu
        });
        submenu.addEventListener("mouseleave", (event) => {
            if (!link.contains(event.relatedTarget)) {
                hideMenu()
            }
        });
    });

});
